import React, { createContext, useContext, useMemo } from 'react';
const DeclaredExperimentsContext = /*#__PURE__*/createContext([]);

/**
 * Release ids the flow declares to the pricing API. A gated pricing strategy is only returned when
 * its id is declared here *and* the release is conducted on for this user, so a flow that provides
 * nothing keeps the ungated pricing — which is what stops one flow's experiment reaching another.
 */
export const DeclaredExperimentsProvider = _ref => {
  let {
    ids,
    children
  } = _ref;
  // Keyed on the contents, so a caller passing a fresh array literal each render does not re-render
  // every consumer.
  const key = ids.join(',');
  // eslint-disable-next-line react-hooks/exhaustive-deps -- keyed on `key`, not `ids`, by design
  const value = useMemo(() => ids, [key]);
  return /*#__PURE__*/React.createElement(DeclaredExperimentsContext.Provider, {
    value: value
  }, children);
};
export const useDeclaredExperiments = () => useContext(DeclaredExperimentsContext);

/**
 * Spread onto a pricing request to declare the flow's release ids.
 *
 * Omitted entirely when the flow declares nothing: an empty `ids` reads to the server as "declared
 * nothing" and is a different request from not asking at all.
 */
export const declaredExperimentsField = ids => ids.length ? {
  experiments: {
    ids
  }
} : {};
//# sourceMappingURL=declaredExperiments.js.map